import { render, staticRenderFns } from "./OrganSelect.vue?vue&type=template&id=6acbaba7&scoped=true"
import script from "./OrganSelect.vue?vue&type=script&lang=js"
export * from "./OrganSelect.vue?vue&type=script&lang=js"
import style0 from "./OrganSelect.vue?vue&type=style&index=0&id=6acbaba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acbaba7",
  null
  
)

export default component.exports